import React, { useEffect, useState } from "react";
import InstructorForm from "./InstructorForm";
import apiClient from "../../utils/apiClient";
import { useNavigate, useParams } from "react-router-dom";
import { Spinner, Alert } from "react-bootstrap";

const initialForm = {
  name: "",
  email: "",
  mobile: "",
  gender: "",
  dob: "",
  avatar: "",
  address: "",
  qualification: "",
  experience: "",
  subject: "",
  otherSkills: "",
  linkedin: "",
  username: "",
  password: "",
  status: "Active",
  about: "",
  joinedDate: "",
  active: true,
};

const EditInstructorPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [form, setForm] = useState(initialForm);
  const [toast, setToast] = useState({ show: false, message: "", type: "success" });
  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");

  useEffect(() => {
    const fetchInstructor = async () => {
      setLoading(true);
      setErr("");
      try {
        const { data } = await apiClient.get(`/instructors/${id}`);
        const instructor = data.instructor;
        setForm({ ...initialForm, ...instructor });
      } catch {
        setErr("Failed to load instructor details.");
      }
      setLoading(false);
    };
    fetchInstructor();
  }, [id]);

  const handleEdit = async (formData) => {
    setSaving(true);
    try {
      await apiClient.put(`/instructors/${id}`, formData);
      setToast({ show: true, message: "Instructor updated successfully!", type: "success" });
      setTimeout(() => navigate(-1), 1200);
    } catch {
      setToast({ show: true, message: "Failed to update instructor.", type: "error" });
    }
    setSaving(false);
  };

  if (loading)
    return <div className="text-center my-5"><Spinner animation="border" /></div>;
  if (err)
    return <Alert variant="danger" className="my-5 text-center">{err}</Alert>;

  return (
    <div>
      <div className="container-fluid px-0 px-md-4">
        <InstructorForm
          initialData={form}
          loading={saving}
          toast={toast}
          setToast={setToast}
          mode="edit"
          onSubmit={handleEdit}
          onCancel={() => navigate(-1)}
        />
      </div>
    </div>
  );
};

export default EditInstructorPage;
